import { useState, useEffect } from "react";
import { FiX, FiArrowLeft } from "react-icons/fi";
import { renderField } from "../utilities/functions";
import FileManager from "./FileManager";

export default function BringMyStoreModal({
  open,
  selectedStores = [],
  spId,
  benId,
  onClose,
  onSave,
  deleteStore
}) {

  const [viewMode, setViewMode] = useState("list");
  // "list" | "add" | "filemanager"

  const [activeStore, setActiveStore] = useState(null);

  const [storetype, setProvider] = useState("google");
  const [id, setDataStoreId] = useState("");
  const [credentials, setCredentials] = useState("");
  const [name, setName] = useState("");
  const providerJRN = spId ? `jrn:serviceprovider:${spId}` : `jrn:beneficiary:${benId}`;
  useEffect(() => {
    if (selectedStores.length === 0) {
      setViewMode("add");
    } else {
      setViewMode("list");
    }
  }, [selectedStores]);

  if (!open) return null;

  const handleSave = () => {
    let datajson = { id, providerJRN, storetype, credentials, name}
    onSave?.(datajson);

    // reset form
    setDataStoreId("");
    setCredentials("");
    setViewMode("list");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-screen-lg bg-gray-900 border border-gray-700 rounded-md relative p-5">

        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
        >
          <FiX size={18} />
        </button>

        {/* HEADER */}
        {viewMode !== "filemanager" && (

          <div className="mb-4 flex items-center gap-3">

            {viewMode === "add" && selectedStores.length > 0 && (
              <button
                onClick={() => setViewMode("list")}
                className="text-gray-400 hover:text-white"
              >
                <FiArrowLeft size={18} />
              </button>
            )}

            <h1 className="text-lg font-semibold text-white">
              {viewMode === "list" ? "Your Stores" : "Save Store"}
            </h1>
          </div>
        )}
        {/* ========================= */}
        {/* STORE LIST VIEW */}
        {/* ========================= */}
        {viewMode === "list" && (
          <>
            <div className="space-y-3 max-h-80 overflow-y-auto">

              {selectedStores.map((store) => (
                <div
                  key={store.id}
                  className="bg-slate-800 p-3 rounded-lg flex justify-between items-center"
                >
                  <div>
                    <div className="text-white font-semibold cursor-pointer" onClick={() => {
                        setActiveStore(store);
                        setViewMode("filemanager");
                      }}>
                      {store.id}-{store.name}
                    </div>
                    <div className="text-gray-400 text-sm">
                      Type: {store.storetype}
                    </div>
                  </div>

                  <div className="flex gap-3">
                    <button
                      onClick={() => {
                        setActiveStore(store);
                        setViewMode("filemanager");
                      }}
                      className="text-blue-400 hover:underline text-sm"
                    >
                      View
                    </button>

                    <button
                      onClick={() => { deleteStore(providerJRN, store.id);
                            setDataStoreId("");
                            setCredentials("");
                            setViewMode("list");
                        }
                      }
                      className="text-red-400 hover:underline text-sm"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}

              {selectedStores.length === 0 && (
                <div className="text-gray-400 text-sm">
                  No stores connected yet.
                </div>
              )}
            </div>

            <div className="mt-5">
              <button
                onClick={() => setViewMode("add")}
                className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-md"
              >
                Add/Update
              </button>
            </div>
          </>
        )}

        {/* ========================= */}
        {/* ADD STORE FORM */}
        {/* ========================= */}
        {viewMode === "add" && (
          <>
            <div className="space-y-5 border border-gray-700 p-4 rounded-md">
              {renderField(
                "Storage Provider",
                "storeProvider",
                "select",
                storetype,
                (e) => setProvider(e.target.value),
                [{ name: "Google Drive", value: "google" }],
                "",
                true
              )}

              {renderField(
                "Data Store ID",
                "storeId",
                "alphanumeric",
                id,
                (e) => setDataStoreId(e.target.value)
              )}
            
              {renderField(
                "Data Store Name",
                "name",
                "alphanumeric",
                name,
                (e) => setName(e.target.value)
              )}

              {renderField(
                "Credentials",
                "credentials",
                "textarea",
                credentials,
                (e) => setCredentials(e.target.value)
              )}
            </div>

            <div className="text-xs text-gray-400 mt-3">
              Saved credentials will be used to connect to the selected provider. If store with same data store Id exists, it will override the existing store.
            </div>

            <div className="flex gap-3 mt-5">
              <button
                type="button"
                onClick={handleSave}
                className="button-style positive-action"
              >
                Save
              </button>

              <button
                type="button"
                onClick={onClose}
                className="button-style"
              >
                Cancel
              </button>
            </div>
          </>
        )}
        {/* ========================= */}
        {/* FILE MANAGER VIEW */}
        {/* ========================= */}
        {viewMode === "filemanager" && activeStore && (
          <>
            <div className="mb-4 flex items-center gap-3">
              <button
                onClick={() => {
                  setViewMode("list");
                  setActiveStore(null);
                }}
                className="text-gray-400 hover:text-white"
              >
                <FiArrowLeft size={18} />
              </button>

              <h1 className="text-lg font-semibold text-white">
                {activeStore.name}
              </h1>
            </div>

            <div className="border border-gray-700 rounded-md p-4 max-h-full overflow-y-auto">
              <FileManager
                providerType={spId ? "serviceprovider" : "beneficiary"}
                providerId={spId ? spId : benId}
                storeId={activeStore.id}
                inline   // optional flag if needed
              />
            </div>
          </>
        )}

      </div>
    </div>
  );
}